/**
 * Keeps the existing native product form available after the main buy buttons
 * leave the viewport. The six launch products each have one purchasable variant.
 */
class StickyAddToCartComponent extends HTMLElement {
  #abort;
  #observer;
  connectedCallback() {
    this.#abort = new AbortController();
    const initialise = () => {
      if (this.#abort.signal.aborted) return;
      const section = this.closest('.shopify-section');
      const productForm = section?.querySelector('product-form-component[data-product-id="' + this.dataset.productId + '"]');
      const buyButtons = productForm?.closest('.buy-buttons-block');
      const bar = this.querySelector('[ref="stickyBar"]');
      const footer = document.querySelector('footer');
      const form = this.querySelector('.sticky-add-to-cart__form');
      if (!buyButtons || !bar || !form) return;
      const refresh = () => {
        const buyBounds = buyButtons.getBoundingClientRect();
        const footerVisible = footer && footer.getBoundingClientRect().top < innerHeight + 200;
        const chat = document.querySelector('shopify-chat')?.getBoundingClientRect();
        const chatVisible = chat && chat.width > 0 && chat.height > 0;
        bar.dataset.stuck = String(buyBounds.bottom < 0 && !footerVisible && !chatVisible);
      };
      this.#observer = new IntersectionObserver(refresh);
      this.#observer.observe(buyButtons);
      if (footer) this.#observer.observe(footer);
      window.addEventListener('scroll', refresh, { passive: true, signal: this.#abort.signal });
      window.addEventListener('resize', refresh, { passive: true, signal: this.#abort.signal });
      form.addEventListener('submit', () => {
        const quantity = productForm.querySelector('input[name="quantity"]');
        const stickyQuantity = form.querySelector('[data-aera-sticky-quantity]');
        if (quantity && stickyQuantity) stickyQuantity.value = quantity.value;
      }, { signal: this.#abort.signal });
      refresh();
    };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initialise, { once: true, signal: this.#abort.signal });
    } else {
      initialise();
    }
  }
  disconnectedCallback() {
    this.#abort?.abort();
    this.#observer?.disconnect();
  }
}
if (!customElements.get('sticky-add-to-cart')) {
  customElements.define('sticky-add-to-cart', StickyAddToCartComponent);
}
